import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import { history } from "../../../helpers/history";
import { useDispatch, useSelector } from "react-redux";
import {
  listFlowcharts,
  listFlowchartArchives,
  resetFlowchartDetails,
} from "./FlowchartActions";
import { getNotification } from "../../components/header/notificationActions";
import Pagination from "../../components/Pagination/Pagination";
import $ from "jquery";
import "./Flowchart.css";
import { CustomerId } from "../../config";
import SearchBox from "src/app/components/SearchBox";

const Flowcharts = () => {
  const [isAdmin] = useState(localStorage.getItem("isAdmin"));
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const dispatch = useDispatch();
  const [sortParams, setSortParams] = useState({
    sortBy: "ASC",
    sortTitle: "flowchartRefId",
  });
  const [showArchives, setShowArchives] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const flowchartData = useSelector((state) => state.flowchartDataReducer);
  const flowchartList =
    flowchartData &&
    flowchartData.flowchartsList &&
    flowchartData.flowchartsList.data;
  const totalCount =
    flowchartData &&
    flowchartData.flowchartsList &&
    flowchartData.flowchartsList.flowchartCount;

  useEffect(() => {
    window.onbeforeunload = null;
    // Listing Flow Charts
    getFlowchartList();
    getNotificationsList();
  }, [searchValue]);

  const getFlowchartList = (page = 1, pageSize = 100) => {
    const data = {
      numPerPage: pageSize,
      page: page == 0 ? 1 : page,
      sortKey: sortParams.sortTitle,
      sortType: sortParams.sortBy,
      searchKey: searchValue,
    };
    dispatch(listFlowcharts(data));
  };

  const getNotificationsList = () => {
    const data = {
      numPerPage: 10,
      page: 1,
      customerId: CustomerId,

      userId: localStorage.getItem("userId"),
    };
    dispatch(getNotification(data));
  };

  const onPageChanged = (data) => {
    if (data && data.currentPage == currentPageNumber) {
      return;
    }
    if (data && data.currentPage) {
      const { currentPage } = data;
      setCurrentPageNumber(currentPage);
      if (showArchives == false) {
        getFlowchartList(currentPage);
      } else if (showArchives == true) {
        getArchivesList(currentPage);
      }
    }
  };

  const goToEditFlowchart = (data) => {
    history.push("/home/addJobTicket", {
      type: 5,
      id: data.id,
      jobId: data.Flowchart.Ticket.id,
    });
  };

  const sortTable = (title) => {
    var sortByOrder = "ASC";

    if (title == sortParams.sortTitle) {
      sortByOrder = sortParams.sortBy == "DESC" ? "ASC" : "DESC";
      setSortParams({ sortBy: sortByOrder, sortTitle: title });
    } else {
      setSortParams({ sortBy: "ASC", sortTitle: title });
    }

    // Call Api here for sorting
    const data = {
      numPerPage: 100,
      page: currentPageNumber,
      sortKey: title,
      sortType: sortByOrder,
      searchKey: searchValue,
    };
    if (showArchives == false) {
      dispatch(listFlowcharts(data));
    } else if (showArchives == true) {
      dispatch(listFlowchartArchives(data));
    }
  };
  const goToCreateFlowchart = () => {
    history.push("/home/addJobTicket", { type: 5 });
  };

  // copy the shared url to clipboard
  const copyToClipboard = (data) => {
    const url =
      data.flowchartType == "upload"
        ? data.fileName
        : window.location.origin + "/previewFlowchart?flowchartId=" + data.id;
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(url).select();
    document.execCommand("copy");
    $temp.remove();
    window.open(url, "_blank", "noreferrer");
  };

  const getArchivesList = (page = 1, pageSize = 100) => {
    const data = {
      numPerPage: pageSize,
      page: page == 0 ? 1 : page,
      sortKey: sortParams.sortTitle,
      sortType: sortParams.sortBy,
      searchKey: "",
    };
    dispatch(listFlowchartArchives(data));
  };

  const goToArchives = () => {
    dispatch(resetFlowchartDetails());
    getArchivesList();
    setShowArchives(true);
  };

  const goToFlowcharts = () => {
    dispatch(resetFlowchartDetails());
    getFlowchartList();
    setShowArchives(false);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="st-tl">
          <h1 className="mh-head-txt pt-3">
            {showArchives == false ? "Flowcharts" : "Archives"}
          </h1>
        </div>
        {showArchives == false && isAdmin == "false" && (
          <div className="aad-usr pt-3">
            <Icon.PlusCircle />
            <a className="a-removed-href-create" onClick={goToCreateFlowchart}>
              Create new Job Ticket for Flowchart
            </a>
          </div>
        )}
      </div>
      <hr className="pb-3" />

      <div className="d-flex justify-content-between mt-5 row">
        <div class="input-group st-tl col-md-4">
          <SearchBox onSearch={handleSearch} />
        </div>
        <div className="aad-usr pt-3 pr-3">
          {showArchives == false ? (
            <div>
              {" "}
              <Icon.Calendar />
              <a className="a-removed-href-create" onClick={goToArchives}>
                Archives
              </a>
            </div>
          ) : (
            <a className="a-removed-href-create" onClick={goToFlowcharts}>
              Go back to Flowcharts
            </a>
          )}
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="table-wraper table-responsive mnt mt-3">
            <table class="table job-list">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="mx-width"
                    onClick={() => {
                      sortTable("flowchartRefId");
                    }}
                  >
                    <div class="d-flex justify-content-start">
                      <div>Doc ID</div>
                      <div class="sort-wrp ml-2">
                        <i
                          class={
                            sortParams.sortTitle == "flowchartRefId" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          class={
                            sortParams.sortTitle == "flowchartRefId" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "flowchartRefId" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>{" "}
                  <th
                    scope="col"
                    onClick={() => {
                      sortTable("flowchartName");
                    }}
                  >
                    <div class="d-flex justify-content-start">
                      <div>Flowchart Name</div>
                      <div class="sort-wrp ml-2">
                        <i
                          class={
                            sortParams.sortTitle == "flowchartName" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          class={
                            sortParams.sortTitle == "flowchartName" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "flowchartName" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th
                    scope="col text-center"
                    onClick={() => {
                      sortTable("revision");
                    }}
                  >
                    <div class="d-flex justify-content-start">
                      <div>Revision</div>
                      <div class="sort-wrp ml-2">
                        <i
                          class={
                            sortParams.sortTitle == "revision" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          class={
                            sortParams.sortTitle == "revision" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "revision" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>{" "}
                  <th
                    scope="col"
                    onClick={() => {
                      sortTable("updatedAt");
                    }}
                  >
                    <div className="d-flex justify-content-start">
                      <div>Date</div>
                      <div className="sort-wrp ml-2">
                        <i
                          className={
                            sortParams.sortTitle == "updatedAt" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          className={
                            sortParams.sortTitle == "updatedAt" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "updatedAt" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th className="text-center" scope="col">
                    Download
                  </th>
                  {showArchives == false && (
                    <th class="text-center" scope="col">
                      Share
                    </th>
                  )}
                  {showArchives == false && isAdmin == "false" && (
                    <th className="text-center" scope="col">
                      Change Request
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {flowchartData &&
                  !flowchartData.loading &&
                  flowchartData.error && (
                    <span className="text-danger">
                      ERROR: {flowchartData.error}
                    </span>
                  )}
                {flowchartList &&
                  flowchartList.map((flowchart, index) => (
                    <tr>
                      <td className="mx-width">{flowchart.flowchartRefId}</td>
                      <td>{flowchart.flowchartName}</td>

                      <td class="text-center">{flowchart.revision}</td>
                      <td>
                        {flowchart.updatedAt
                          ? flowchart.updatedAt.split("T")[0]
                          : "Not Approved"}
                      </td>
                      <td
                        className={
                          flowchart.flowchartType == "manual"
                            ? "text-center disabled-btn"
                            : "text-center"
                        }
                      >
                        <a href={flowchart.fileName} className="a-removed-href">
                          <Icon.Download />
                        </a>
                      </td>
                      {showArchives == false && (
                        <td class="text-center">
                          <a
                            className="a-removed-href"
                            onClick={() => copyToClipboard(flowchart)}
                          >
                            <Icon.Share />
                          </a>
                        </td>
                      )}
                      {showArchives == false && isAdmin == "false" && (
                        <td className="text-center">
                          <a
                            className="a-removed-href"
                            onClick={() => goToEditFlowchart(flowchart)}
                          >
                            Raise Ticket
                          </a>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
            {flowchartData.flowchartsList.flowchartCount <= 0 && (
              <p class="text-center font-italic font-weight-bold">
                No data available!
              </p>
            )}
            {flowchartData.flowchartsList.flowchartCount > 0 && (
              <div className="d-flex flex-row py-4 align-items-center float-left">
                Total Count: {flowchartData.flowchartsList.flowchartCount}
              </div>
            )}

            <div className="d-flex flex-row py-4 align-items-center float-right">
              {flowchartData.flowchartsList.flowchartCount > 0 && (
                <Pagination
                  totalRecords={totalCount}
                  pageLimit={100}
                  pageNeighbours={0}
                  onPageChanged={onPageChanged}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flowcharts;
